export var ChatWindowIngressCommand;
(function (ChatWindowIngressCommand) {
    ChatWindowIngressCommand["WORKER_READY"] = "worker_ready";
    ChatWindowIngressCommand["INIT_RESULT"] = "init_result";
    ChatWindowIngressCommand["RECONNECT_RESULT"] = "reconnect_result";
    ChatWindowIngressCommand["EVENT_CONNECTING"] = "ev_connecting";
    ChatWindowIngressCommand["EVENT_ESTABLISHED"] = "ev_connection_established";
    ChatWindowIngressCommand["EVENT_DISCONNECT"] = "ev_disconnect";
    ChatWindowIngressCommand["CHATLIST_SUB_RESULT"] = "chatlist_sub_result";
    ChatWindowIngressCommand["CHATLIST_SUB_CB_RESULT"] = "chatlist_sub_cb_result";
    ChatWindowIngressCommand["CHATROOM_SUB_RESULT"] = "chatroom_sub_result";
    ChatWindowIngressCommand["CHATROOM_ON_CHANGE"] = "chatroom_on_change";
    ChatWindowIngressCommand["CHATROOM_ON_INITIAL_FETCH"] = "chatroom_on_init_fetch";
    ChatWindowIngressCommand["CHATROOM_ON_NEW_MESSAGE"] = "chatroom_on_new_message";
    ChatWindowIngressCommand["CHATROOM_ON_ERROR"] = "chatroom_on_error";
    ChatWindowIngressCommand["CHAT_GLOBAL_UNREAD_CHANGE"] = "chat_global_unread_change";
    ChatWindowIngressCommand["CHAT_GLOBAL_UNREAD_SUB_RESULT"] = "chat_global_unread_sub_result";
    ChatWindowIngressCommand["CHAT_UNSEEN_SUB_RESULT"] = "chat_unseen_sub_result";
    ChatWindowIngressCommand["CHAT_UNSEEN_CHANGE"] = "chat_unseen_change";
    ChatWindowIngressCommand["CHAT_UNSEEN_MARKED_RESULT"] = "chat_unseen_marked_result";
    ChatWindowIngressCommand["CHAT_SEND_MSG_RESULT"] = "chat_send_msg_result";
    ChatWindowIngressCommand["CHAT_ADD_MSG_RESULT"] = "chat_add_msg_result";
    ChatWindowIngressCommand["CHAT_DELETE_MSG_RESULT"] = "chat_delete_msg_result";
    ChatWindowIngressCommand["CHAT_NOTIFY_TYPING_RESULT"] = "chat_notify_typing_result";
    ChatWindowIngressCommand["CHAT_NOTIFY_TYPING_TEXT_CHANGE_RESULT"] = "chat_notify_typing_changed_result";
    ChatWindowIngressCommand["CHAT_DELETE_CHATROOM_RESULT"] = "chat_delete_chatroom_result";
    ChatWindowIngressCommand["CHAT_DELETE_CHATROOMS_RESULT"] = "chat_delete_chatrooms_result";
    ChatWindowIngressCommand["CHAT_SET_LAST_MESSAGE_UNREAD_RESULT"] = "chat_set_last_message_unread_result";
    ChatWindowIngressCommand["CHAT_SET_ALL_ROOMS_AS_READ_RESULT"] = "chat_set_all_rooms_read_result";
    ChatWindowIngressCommand["CHAT_SET_MESSAGES_READ_RESULT"] = "chat_set_messages_read_result";
    ChatWindowIngressCommand["CHAT_SET_ROOMS_MESSAGES_READ_RESULT"] = "chat_set_rooms_messages_read_result";
    ChatWindowIngressCommand["CHAT_GET_MESSAGES_PAGE_RESULT"] = "chat_get_messages_page_result";
    ChatWindowIngressCommand["CHAT_REALTIME_MESSAGES_SUB_RESULT"] = "chat_realtime_msg_sub_result";
    ChatWindowIngressCommand["CHAT_REALTIME_MESSAGE_RESULT"] = "chat_realtime_msg_result";
})(ChatWindowIngressCommand || (ChatWindowIngressCommand = {}));
export var ChatWorkerEgressCommand = ChatWindowIngressCommand; // eslint-disable-line
export var ChatWindowEgressCommand;
(function (ChatWindowEgressCommand) {
    ChatWindowEgressCommand["INIT"] = "init";
    ChatWindowEgressCommand["CLEAR"] = "clear";
    ChatWindowEgressCommand["DISCONNECT"] = "disconnect";
    ChatWindowEgressCommand["RECONNECT"] = "reconnect";
    ChatWindowEgressCommand["CHATLIST_SUB"] = "chatlist_sub";
    ChatWindowEgressCommand["CHATLIST_UNSUB"] = "chatlist_unsub";
    ChatWindowEgressCommand["CHATLIST_FETCHMORE"] = "chatlist_fetchmore";
    ChatWindowEgressCommand["CHATROOM_SUB"] = "chatroom_sub";
    ChatWindowEgressCommand["CHATROOM_UNSUB"] = "chatroom_unsub";
    ChatWindowEgressCommand["CHATROOM_FETCHMORE"] = "chatroom_fetchmore";
    ChatWindowEgressCommand["CHAT_SUB_GLOBAL_UNREAD"] = "chat_sub_global_unread";
    ChatWindowEgressCommand["CHAT_UNSUB_GLOBAL_UNREAD"] = "chat_unsub_global_unread";
    ChatWindowEgressCommand["CHAT_UNSEEN_SUB"] = "chat_unseen_sub";
    ChatWindowEgressCommand["CHAT_UNSEEN_UNSUB"] = "chat_unseen_unsub";
    ChatWindowEgressCommand["CHAT_UNSEEN_MARK_SEEN"] = "chat_unseen_mark_seen";
    ChatWindowEgressCommand["CHAT_SEND_MSG"] = "chat_send_msg";
    ChatWindowEgressCommand["CHAT_ADD_MSG"] = "chat_add_msg";
    ChatWindowEgressCommand["CHAT_DELETE_MSG"] = "chat_delete_msg";
    ChatWindowEgressCommand["CHAT_NOTIFY_TYPING"] = "chat_notify_typing";
    ChatWindowEgressCommand["CHAT_NOTIFY_TYPING_TEXT_CHANGED"] = "chat_notify_typing_changed";
    ChatWindowEgressCommand["CHAT_DELETE_CHATROOM"] = "chat_delete_chatroom";
    ChatWindowEgressCommand["CHAT_DELETE_CHATROOMS"] = "chat_delete_chatrooms";
    ChatWindowEgressCommand["CHAT_SET_LAST_MESSAGE_UNREAD"] = "chat_set_last_msg_unread";
    ChatWindowEgressCommand["CHAT_SET_ALL_ROOMS_READ"] = "chat_set_all_rooms_read";
    ChatWindowEgressCommand["CHAT_SET_MESSAGES_READ"] = "chat_set_messages_read";
    ChatWindowEgressCommand["CHAT_SET_ROOMS_MESSAGES_READ"] = "chat_set_rooms_messages_read";
    ChatWindowEgressCommand["CHAT_GET_MESSAGES_PAGE"] = "chat_get_messages_page";
    ChatWindowEgressCommand["CHAT_LISTEN_REALTIME_MESSAGES"] = "chat_listen_realtime_messages";
    ChatWindowEgressCommand["CHAT_REALTIME_MESSAGES_UNSUB"] = "chat_realtime_messages_unsub";
    ChatWindowEgressCommand["WORKER_SET_THROTTLE"] = "worker_set_throttle";
    ChatWindowEgressCommand["WORKER_IDLE_START"] = "worker_idle_start";
    ChatWindowEgressCommand["WORKER_IDLE_END"] = "worker_idle_end";
    ChatWindowEgressCommand["WORKER_SET_CHAT_TOKEN"] = "worker_set_chat_token";
})(ChatWindowEgressCommand || (ChatWindowEgressCommand = {}));
export var ChatWorkerIngressCommand = ChatWindowEgressCommand; // eslint-disable-line
var BaseCommand = /** @class */ (function () {
    function BaseCommand() {
    }
    return BaseCommand;
}());
export { BaseCommand };
//# sourceMappingURL=types.js.map